<template>
    <v-select
        :placeholder="placeholder"
        :class="{ 'x-select': true, 'no-props': propsItem.length < 1 }"
        :options="options"
        :reduce="tag => tag._id.$oid"
        :calculate-position="withPopper"
        v-model="propsItem"
        ref="tag-select"
        label="name"
        multiple
        @input="
            value => {
                this.$emit('change', value)
            }
        "
    >
        <template slot="option" slot-scope="option">
            <div class="d-flex">
                {{ option.name }}
                <span
                    class="ml-3 badge badge-pill"
                    :class="{
                        'badge-danger': option.type === 'quiz',
                        'badge-warning': option.type === 'question',
                        'badge-info': option.type === 'category'
                    }"
                >
                    {{ option.type }}
                </span>
            </div>
        </template>

        <template #no-options>{{ $t('sorry_no_natching_options') }}</template>
    </v-select>
</template>

<script>
import { createPopper } from '@popperjs/core'
import appConfig from '@/app.config.js'
import Request from '@/lib/request.js'

export default {
    props: {
        tags: {
            type: Array,
            default() {
                return []
            }
        },
        addonType: {
            type: String,
            default: 'category'
        },

        placeholder: {
            type: String
        }
    },

    mounted() {
        this.getTags()
    },

    data() {
        return {
            propsItem: [],
            options: []
        }
    },

    methods: {
        getTags() {
            const request = new Request()
            const payload = {
                params: {
                    type: this.addonType == 'all' ? '' : this.addonType
                }
            }

            request.get(appConfig.api.getCategoryTags, payload).then(res => {
                let allTags = res.data.data.data

                if (allTags.length > 0) {
                    this.options = allTags.sort((a, b) => (a.name > b.name ? 1 : -1))

                    if (this.tags.length > 0) {
                        this.propsItem = this.options.filter(item => this.tags.indexOf(item._id.$oid) > -1)
                    }
                }
            })
        },

        withPopper(dropdownList, component, { width }) {
            dropdownList.style.width = width
            const popper = createPopper(component.$refs.toggle, dropdownList, {
                placement: this.placement,
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -1]
                        }
                    },
                    {
                        name: 'toggleClass',
                        enabled: true,
                        phase: 'write',
                        fn({ state }) {
                            component.$el.classList.toggle('drop-up', state.placement === 'top')
                        }
                    }
                ]
            })
            return () => popper.destroy()
        }
    }
}
</script>
